import { render } from "./CampaignGeneralScope.vue?vue&type=template&id=66448a60&scoped=true"
import script from "./CampaignGeneralScope.vue?vue&type=script&lang=js"
export * from "./CampaignGeneralScope.vue?vue&type=script&lang=js"

import "./CampaignGeneralScope.vue?vue&type=style&index=0&id=66448a60&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66448a60"]])

export default __exports__